import { toast } from "sonner";

function normalizePhone(phone) {
  const digits = String(phone || "").replace(/[^\d]/g, "");
  if (!digits) return "";
  // If exactly 10 digits, auto-prepend India country code 91
  if (digits.length === 10) return "91" + digits;
  return digits;
}

export function buildReminderMessage(s) {
  if (s.days_left < 0) {
    return `Hi ${s.name}, your Pathaans Academy Ludhiana module expired ${Math.abs(s.days_left)} day(s) ago on ${s.end_date}. Please renew to continue your training. Thanks!`;
  }
  if (s.days_left === 0) {
    return `Hi ${s.name}, your Pathaans Academy Ludhiana module expires TODAY (${s.end_date}). Please renew to continue your training. Thanks!`;
  }
  return `Hi ${s.name}, this is a friendly reminder that your Pathaans Academy Ludhiana module ends in ${s.days_left} day(s) on ${s.end_date}. Please contact us to renew. Thanks!`;
}

export function buildCoachNotifyMessage(coachName, s) {
  const status =
    s.days_left < 0
      ? `expired ${Math.abs(s.days_left)} day(s) ago on ${s.end_date}`
      : s.days_left === 0
      ? `expires TODAY (${s.end_date})`
      : `ends in ${s.days_left} day(s) on ${s.end_date}`;
  const pending = Number(s.pending_fee || 0) > 0
    ? ` Pending fee: ₹${Number(s.pending_fee).toLocaleString("en-IN")}${s.next_due_date ? ` (due ${s.next_due_date})` : ""}.`
    : "";
  return `Hi ${coachName || "Coach"}, quick reminder about ${s.name} (${s.phone_number || "no phone"}): module ${status}.${pending} Please follow up. — Pathaans Academy Ludhiana`;
}

export function buildReceiptMessage(s) {
  const today = new Date();
  const y = today.getFullYear();
  const m = String(today.getMonth() + 1).padStart(2, "0");
  const d = String(today.getDate()).padStart(2, "0");
  const receiptId = `${y}${m}${d}-${(s.id || "").slice(0, 6).toUpperCase()}`;
  return (
    `*Pathaans Academy E-Receipt*\n` +
    `Receipt No: ${receiptId}\n` +
    `Date: ${y}-${m}-${d}\n` +
    `Name: ${s.name}\n` +
    `Phone: ${s.phone_number}\n` +
    `Module: ${s.start_date} to ${s.end_date}\n\n` +
    `Thank you for being a part of Pathaans Academy Ludhiana!`
  );
}

export function buildFeeReminderMessage(s) {
  const amount = Number(s.pending_fee || 0).toLocaleString("en-IN", {
    maximumFractionDigits: 2,
  });
  const due = s.next_due_date || "";
  const today = new Date();
  const dueDate = due ? new Date(due) : today;
  const days = Math.floor((dueDate - today) / (1000 * 60 * 60 * 24));
  if (days < 0) {
    return `Hi ${s.name}, your pending fee of ₹${amount} at Pathaans Academy Ludhiana was due on ${due}. Please clear it at the earliest to continue your training. Thanks!`;
  }
  if (days === 0) {
    return `Hi ${s.name}, this is a reminder that your pending fee of ₹${amount} at Pathaans Academy Ludhiana is due TODAY (${due}). Please clear it. Thanks!`;
  }
  return `Hi ${s.name}, this is a reminder that your pending fee of ₹${amount} at Pathaans Academy Ludhiana is due on ${due} (in ${days} day(s)). Please clear it on time. Thanks!`;
}

export const QUICK_TEMPLATES = [
  { key: "absence", label: "Absence", body: (s) => `Hi ${s.name}, we noticed you missed today's session at Pathaans Academy Ludhiana. Is everything okay? Please let us know if you need any support.` },
  { key: "great", label: "Great Performance", body: (s) => `Hi ${s.name}, great work at practice today! Keep up the intensity — you're improving fast. — Pathaans Academy Ludhiana` },
  { key: "improve", label: "Needs Improvement", body: (s) => `Hi ${s.name}, we'd love to see you push a bit harder in the next few sessions. Consistency will really unlock your game. — Pathaans Academy Ludhiana` },
  { key: "practice", label: "Practice Reminder", body: (s) => `Hi ${s.name}, this is a reminder for your upcoming session at Pathaans Academy Ludhiana. See you on the ground!` },
  { key: "fee", label: "Fee Pending", body: (s) => `Hi ${s.name}, this is a gentle reminder about your pending fee of ₹${Number(s.pending_fee || 0).toLocaleString("en-IN")} at Pathaans Academy Ludhiana. Please clear it at your earliest convenience.` },
];

export function openWhatsApp(phone, message) {
  const digits = normalizePhone(phone);
  if (!digits) {
    toast.error("No valid WhatsApp number is saved for this contact.");
    return;
  }
  const text = encodeURIComponent(message);
  const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent || "");
  if (isMobile) {
    // whatsapp:// is the native deep link — it hands off to the WhatsApp
    // app directly and never loads any interstitial page, so there's
    // nothing left parked in this tab afterward (unlike wa.me).
    window.location.href = `whatsapp://send?phone=${digits}&text=${text}`;
    return;
  }
  // Desktop has no WhatsApp app to deep-link to, so send it through
  // wa.me/WhatsApp Web in a separate tab.
  const url = `https://wa.me/${digits}?text=${text}`;
  const a = document.createElement("a");
  a.href = url;
  a.target = "_blank";
  a.rel = "noopener noreferrer";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}
